const MetaInfo = {
  props: {
    maxLength: {
      required: false,
      type: Number,
      default: 0,
    },
    placeholder: {
      required: false,
      default: '...',
    },
    value: {
      required: false,
      default: ''
    }
  },
  data() {
    return {
      text: ''
    }
  },
  computed: {
    cssObject() {
      return {
        'text-success': (this.length !== 0) && (this.diff > 0),
        'text-danger': (this.diff < 0),
        'text-muted': (this.length === 0)
      }
    },
    length() {
      return this.text.length;
    },
    diff() {
      return parseInt(this.maxLength) - parseInt(this.length);
    }
  },
  watch: {
    text(value) {
      this.$emit('input', value);
    }
  },
  mounted() {
    this.text = (this.value == null) ? '' : this.value;
  }
};

export default MetaInfo;
